import { ArsSidebarItemVariable, isArsSidebarItemData } from "../../sidebar";
import {
  ArslActionApplyDroppedSortColumns,
  ArsListingState,
  ArsListingVariableEnum,
} from "../interface";

/**
 * Add sort columns to the target column in the listing state when they are dropped
 * from the sidebar. The dropped columns are inserted at the specified variableIndex.
 *
 * @param state - The current state of the ARS listing.
 * @param action - The action containing the details of the dropped sort columns
 * @returns - The updated state of the ARS listing with the new sort columns added
 */
export const arsl_applyDroppedSortColumns = <T>(
  state: ArsListingState<T>,
  action: ArslActionApplyDroppedSortColumns,
): ArsListingState<T> => {
  const targetColumnVars = state.bodyData.arsListingColumns.find(
    (column) => column.id === action.colId,
  )?.variables;
  if (!targetColumnVars) return state;

  /* Get jsonPayload - should be ArsSidebarItemVariable[] */

  try {
    const jsonData = JSON.parse(action.jsonPayload).data;

    if (
      !jsonData ||
      !Array.isArray(jsonData) ||
      !jsonData.length ||
      jsonData.some((item) => !isArsSidebarItemData(item) || item.kind !== "variable")
    )
      return state;
    const newSortVars = jsonData.map((item: ArsSidebarItemVariable) => ({
      id: crypto.randomUUID(),
      dataset: item.dropItem.dataset,
      variable: item.dropItem.name,
      variableType: ArsListingVariableEnum.HiddenSortAscending,
    }));

    const newVariables = [
      ...targetColumnVars.slice(0, action.variableIndex),
      ...newSortVars,
      ...targetColumnVars.slice(action.variableIndex),
    ];

    const newColumns = state.bodyData.arsListingColumns.map((column) =>
      column.id === action.colId ? { ...column, variables: newVariables } : column,
    );

    const newState: ArsListingState<T> = {
      ...state,
      bodyData: {
        ...state.bodyData,
        arsListingColumns: newColumns,
      },
      changed: true,
    };

    // Check new datasets
    if (newSortVars.some((ds) => !state.datasets.has(ds.dataset))) {
      newState.datasets = new Set([...state.datasets, ...newSortVars.map((v) => v.dataset)]);
    }

    return newState;
  } catch {
    return state;
  }
};
